module.exports = __webpack_public_path__ + "static/media/Our-Culture-Code.5a224eee.webp";